import { render, staticRenderFns } from "./ItemComponent.vue?vue&type=template&id=24cb297b&scoped=true"
import script from "./ItemComponent.vue?vue&type=script&lang=js"
export * from "./ItemComponent.vue?vue&type=script&lang=js"
import style0 from "./ItemComponent.vue?vue&type=style&index=0&id=24cb297b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cb297b",
  null
  
)

export default component.exports